<template>
  <div class="container">
    <el-card>
      <div slot="header">同比报表</div>
      <div style="height: 100%">
        <el-tabs v-model="activeName" type="border-card">
          <el-tab-pane label="电表同比报表" name="electric">
            <div style="display: flex; height: 100%">
              <div class="leftTree">
                <MerchantTree ref="merchantTreeMeterCompare" :showCheckBox="false" v-on:treeMenuClick="treeMenuClick"></MerchantTree>
              </div>
              <div class="rightTable">
                <div class="echartStyle">
                  <div class="title">
                    <span>商户总量月度同比数据统计：</span>
                    <div class="monthForm">
                      <span>月度：</span>
                      <el-date-picker v-model="electricMonth" type="month" size="small" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择月" class="datePickerWidth" @change="electricMonthChange">
                      </el-date-picker>
                    </div>
                    <div class="btns">
                      <el-button type="primary" size="small" @click="getSelectMeterYearlyMonthlyDataTotal">全局统计</el-button>
                      <el-button type="primary" size="small" @click="exportToExcelElectric">
                        导出excel</el-button>
                    </div>
                  </div>

                </div>
                <div class="tableStyle">
                  <el-table :data="electricTableData" id="electricCompareTableId" style="width: 100%" height="92%">
                    <el-table-column prop="lesseeCode" label="商户编号" width="150" align="center">
                    </el-table-column>
                    <el-table-column prop="lesseeName" label="商户名称" width="150" align="center">
                    </el-table-column>
                    <el-table-column prop="curMonth" label="本期月度" width="120" align="center">
                    </el-table-column>
                    <el-table-column prop="curValue" label="本期用电总量(kW·h)" width="150" align="center">
                    </el-table-column>
                    <el-table-column prop="yearlyMonth" label="同比月度" width="150" align="center">
                    </el-table-column>
                    <el-table-column prop="yearlyValue" label="同比期用电总量(kW·h)" width="100" align="center">
                    </el-table-column>
                    <el-table-column prop="yearlyPercent" label="同比增长率" width="100" align="center">
                    </el-table-column>
                    <el-table-column prop="monthlyMonth" label="环比月度" width="100" align="center">
                    </el-table-column>
                    <el-table-column prop="monthlyValue" label="环比期用电总量(kW·h)" width="100" align="center">
                    </el-table-column>
                    <el-table-column prop="monthlyPercent" label="环比增长率" width="150" align="center">
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="水表同比报表" name="water">
            <div style="display: flex; height: 100%">
              <div class="leftTree">
                <MerchantTree ref="merchantTreeWaterCompare" :showCheckBox="false" v-on:treeMenuClick="treeMenuClickWater"></MerchantTree>
              </div>
              <div class="rightTable">
                <div class="echartStyle">
                  <div class="title">
                    <span>商户总量月度同比数据统计：</span>
                    <div class="monthForm">
                      <span>月度：</span>
                      <el-date-picker v-model="waterMonth" type="month" size="small" placeholder="选择月" value-format="yyyy-MM-dd HH:mm:ss" class="datePickerWidth" @change="waterMonthChange">
                      </el-date-picker>
                    </div>
                    <div class="btns">
                      <el-button type="primary" size="small" @click="getSelectWaterYearlyMonthlyDataTotal">全局统计</el-button>
                      <el-button type="primary" size="small" @click="exportToExcelWater">导出excel
                      </el-button>
                    </div>
                  </div>

                  <div class="container">
                    <div class="leftEchart">
                      <div class="pieChart" id="waterTongbiChart"></div>
                    </div>
                    <div class="rightEchart">
                      <div class="pieChart" id="waterHuanbiChart"></div>
                    </div>
                  </div>
                </div>
                <div class="tableStyle">
                  <el-table :data="waterTableData" id="waterCompareTableId" style="width: 100%" height="92%">
                    <el-table-column prop="lesseeCode" label="商户编号" width="150" align="center">
                    </el-table-column>
                    <el-table-column prop="lesseeName" label="商户名称" width="150" align="center">
                    </el-table-column>
                    <el-table-column prop="curMonth" label="本期月度" width="120" align="center">
                    </el-table-column>
                    <el-table-column prop="curValue" label="本期用水总量(m³)" width="150" align="center">
                    </el-table-column>
                    <el-table-column prop="yearlyMonth" label="同比月度" width="150" align="center">
                    </el-table-column>
                    <el-table-column prop="yearlyValue" label="同比期用水总量(m³)" width="100" align="center">
                    </el-table-column>
                    <el-table-column prop="yearlyPercent" label="同比增长率" width="100" align="center">
                    </el-table-column>
                    <el-table-column prop="monthlyMonth" label="环比月度" width="100" align="center">
                    </el-table-column>
                    <el-table-column prop="monthlyValue" label="环比期用水总量(m³)" width="100" align="center">
                    </el-table-column>
                    <el-table-column prop="monthlyPercent" label="环比增长率" width="150" align="center">
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-card>
  </div>
</template>

<script>
import MerchantTree from '../property/MerchantTree.vue';
import * as echarts from 'echarts';
import {
  selectMeterYearlyMonthlyData,
  selectMeterYearlyMonthlyDataTotal,
  selectWaterYearlyMonthlyData,
  selectWaterYearlyMonthlyDataTotal,
} from '../../api/report/compareReport';
import exportTable from '../../untils/exportTable';
import { getCurMonthFirstTime } from '../../untils/func'

export default {
  components: {
    MerchantTree,
  },
  data () {
    return {
      activeName: 'electric',
      // 查询参数
      queryParams: {
        current: 1,
        size: 10,
        name: '',
      },
      loading: false,
      electricTableData: [],
      waterTableData: [],
      currentNodeId: null, //电表当前nodeid
      currentNodeIdWater: null, //水表当前nodeid
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      electricTongPieChart: '',
      electricHuanPieChart: '',
      waterHuanPieChart: '',
      waterTongPieChart: '',
      electricMonth: getCurMonthFirstTime(), //电表同比月份model
      waterMonth: getCurMonthFirstTime(), //水表同比月份model
      electricTongChartData: [], //电表同比echart数据
      electricHuanChartData: [], //电表环比echart数据
      waterTongChartData: [], //水表同比echart数据
      waterHuanChartData: [], //水表环比echart数据
    };
  },
  created () { },
  mounted () {
    this.init();
    // 重置图表
    window.addEventListener('resize', this.resizeChart);
  },
  watch: {
    $route (to) {
      if (to.path == '/mainWindow/compareReport') {
        this.resizeChart();
      }
    },
    activeName (newVal) {
      if (newVal === 'electric') {
        this.$nextTick(() => {
          this.createElectricTongEchart();
          this.createElectricHuanEchart();
        });
      } else if (newVal === 'water') {
        this.$nextTick(() => {
          this.createWaterHuanEchart();
          this.createWaterTongEchart();
        });
      }
    },
  },
  methods: {
    async init () {
      // await this.getSelectMeterYearlyMonthlyData();
      // if (this.activeName == 'electric') {
      await this.getSelectMeterYearlyMonthlyDataTotal();
      // } else if (this.activeName == 'water') {
      await this.getSelectWaterYearlyMonthlyDataTotal();
      // }
    },
    // 电表单个商户
    async getSelectMeterYearlyMonthlyData () {
      if (!this.currentNodeId) {
        this.$message.error('请先点击某个商户名称！');
      } else if (!this.electricMonth) {
        this.$message.error('请先选择月份！');
      } else {
        const res = await selectMeterYearlyMonthlyData({
          lesseeId: this.currentNodeId,
          date: this.electricMonth,
        }).then();

        this.electricTongChartData = res.data.yearlyData;
        this.electricHuanChartData = res.data.monthlyData;
        this.electricTableData = res.data.tableData;
        this.createElectricTongEchart();
        this.createElectricHuanEchart();
      }
    },
    // 电表所有商户
    async getSelectMeterYearlyMonthlyDataTotal () {
      if (!this.electricMonth) {
        this.$message.error('请先选择月份！');
      } else {
        const res = await selectMeterYearlyMonthlyDataTotal({
          date: this.electricMonth,
        }).then();
        this.electricTongChartData = res.data.yearlyData;
        this.electricHuanChartData = res.data.monthlyData;
        this.electricTableData = res.data.tableData;

        this.createElectricTongEchart();
        this.createElectricHuanEchart();
      }
    },
    // 水表单个商户
    async getSelectWaterYearlyMonthlyData () {
      if (!this.currentNodeIdWater) {
        this.$message.error('请先点击某个商户名称！');
      } else if (!this.waterMonth) {
        this.$message.error('请先选择月份！');
      } else {
        const res = await selectWaterYearlyMonthlyData({
          lesseeId: this.currentNodeIdWater,
          date: this.waterMonth,
        }).then();
        this.waterTongChartData = res.data.yearlyData;
        this.waterHuanChartData = res.data.monthlyData;
        this.waterTableData = res.data.tableData;

        this.createWaterHuanEchart();
        this.createWaterTongEchart();
      }
    },
    // 水表所有商户
    async getSelectWaterYearlyMonthlyDataTotal () {
      if (!this.waterMonth) {
        this.$message.error('请先选择月份！');
      } else {
        const res = await selectWaterYearlyMonthlyDataTotal({
          date: this.waterMonth,
        }).then();

        this.waterTongChartData = res.data.yearlyData;
        this.waterHuanChartData = res.data.monthlyData;
        this.waterTableData = res.data.tableData;

        this.createWaterHuanEchart();
        this.createWaterTongEchart();
      }
    },
    //电表月份change
    async electricMonthChange () {
      if (this.currentNodeId) {
        await this.getSelectMeterYearlyMonthlyData();
      } else {
        await this.getSelectMeterYearlyMonthlyDataTotal();
      }
    },
    //水表月份change
    async waterMonthChange () {
      if (this.currentNodeIdWater) {
        await this.getSelectWaterYearlyMonthlyData();
      } else {
        await this.getSelectWaterYearlyMonthlyDataTotal();
      }
    },
    async treeMenuClick () {
      this.currentNodeId = this.$refs.merchantTreeMeterCompare.nodeId;
      await this.getSelectMeterYearlyMonthlyData();
    },
    async treeMenuClickWater () {
      this.currentNodeIdWater = this.$refs.merchantTreeWaterCompare.nodeId;
      await this.getSelectWaterYearlyMonthlyData();
    },
    async exportToExcelElectric () {
      if (this.electricTableData.length === 0) {
        this.$message.warning('无数据');
        return;
      } else {
        exportTable.exportExcel('electricCompareTableId', '电表同比环比报表');
      }
    },
    async exportToExcelWater () {
      if (this.waterTableData.length === 0) {
        this.$message.warning('无数据');
        return;
      } else {
        exportTable.exportExcel('waterCompareTableId', '水表同比环比报表');
      }
    },
    resizeChart () {
      this.electricTongPieChart ? this.electricTongPieChart.resize() : '';
      this.electricHuanPieChart ? this.electricHuanPieChart.resize() : '';
      this.waterHuanPieChart ? this.waterHuanPieChart.resize() : '';
      this.waterTongPieChart ? this.waterTongPieChart.resize() : '';
    },
    createElectricTongEchart () {
      var chartDom = document.getElementById('electricTongbiChart');
      this.electricTongPieChart = echarts.init(chartDom);
      var option = {
        title: {
          text: '电表同比',
          top: 20,
          left: 0,
        },
        color: ['#61a5e8', '#7ecf51', '#eecb5f', '#e3935d', '#e16757'],
        tooltip: {
          trigger: 'item',
        },
        // legend: {
        //   orient: 'vertical',
        //   left: 'left',
        // },
        series: [{
          name: '电表同比',
          type: 'pie',
          radius: '60%',
          center: ['40%', '50%'],
          data: this.electricTongChartData,
          label: {
            normal: {
              show: false,
            },
          },
          labelLine: {
            normal: {
              show: false,
            },
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)',
            },
          },
        },],
      };

      option && this.electricTongPieChart.setOption(option);
      this.electricTongPieChart.resize();
    },
    createElectricHuanEchart () {
      var chartDom = document.getElementById('electricHuanbiChart');
      this.electricHuanPieChart = echarts.init(chartDom);
      var option = {
        title: {
          text: '电表环比',
          top: 20,
          left: 0,
        },
        color: ['#61a5e8', '#7ecf51', '#eecb5f', '#e3935d', '#e16757'],
        tooltip: {
          trigger: 'item',
        },
        // legend: {
        //   orient: 'vertical',
        //   left: 'left',
        // },
        series: [{
          name: '电表环比',
          type: 'pie',
          radius: '60%',
          center: ['40%', '50%'],
          data: this.electricHuanChartData,
          label: {
            normal: {
              show: false,
            },
          },
          labelLine: {
            normal: {
              show: false,
            },
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)',
            },
          },
        },],
      };

      option && this.electricHuanPieChart.setOption(option);
      this.electricHuanPieChart.resize();
    },
    createWaterHuanEchart () {
      var chartDom = document.getElementById('waterHuanbiChart');
      this.waterHuanPieChart = echarts.init(chartDom);
      var option = {
        title: {
          text: '水表环比',
          top: 20,
          left: 0,
        },
        color: ['#61a5e8', '#7ecf51', '#eecb5f', '#e3935d', '#e16757'],
        tooltip: {
          trigger: 'item',
        },
        // legend: {
        //   orient: 'vertical',
        //   left: 'left',
        // },
        series: [{
          name: '水表环比',
          type: 'pie',
          radius: '60%',
          center: ['40%', '50%'],
          data: this.waterHuanChartData,
          label: {
            normal: {
              show: false,
            },
          },
          labelLine: {
            normal: {
              show: false,
            },
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)',
            },
          },
        },],
      };

      option && this.waterHuanPieChart.setOption(option);
      this.waterHuanPieChart.resize();
    },
    createWaterTongEchart () {
      var chartDom = document.getElementById('waterTongbiChart');
      this.waterTongPieChart = echarts.init(chartDom);
      var option = {
        title: {
          text: '水表同比',
          top: 20,
          left: 0,
        },
        color: ['#61a5e8', '#7ecf51', '#eecb5f', '#e3935d', '#e16757'],
        tooltip: {
          trigger: 'item',
        },
        // legend: {
        //   orient: 'vertical',
        //   left: 'left',
        // },
        series: [{
          name: '水表同比',
          type: 'pie',
          radius: '60%',
          center: ['40%', '50%'],
          data: this.waterTongChartData,
          label: {
            normal: {
              show: false,
            },
          },
          labelLine: {
            normal: {
              show: false,
            },
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)',
            },
          },
        },],
      };

      option && this.waterTongPieChart.setOption(option);
      this.waterTongPieChart.resize();
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 0 10px;
  height: 100%;
}

/deep/ .el-card__header {
  background-color: var(--secondColor) !important;
  color: var(--whiteColor);
}

/deep/ .el-form-item {
  display: inline-block;
}

.searchTag {
  width: 200px;
}

/deep/ .el-tabs {
  height: 100% !important;

  .el-tabs__content {
    height: calc(100% - 39px) !important;
  }
}

/deep/ .el-tabs__content {
  height: 100% !important;
}

.el-dialog {
  .el-form-item {
    width: 100%;

    .el-input {
      width: 100%;
    }
  }
}

/deep/ .el-input-group__append {
  cursor: pointer;
}

.leftTree {
  width: 30vw;
  height: 100%;
  min-width: 180px;
  margin-right: 20px;
}

.rightTable {
  // width: calc(100% - 200px);

  .echartStyle {
    height: 10%;

    .title {
      display: flex;
      width: 100%;
      // justify-content: space-between;
      line-height: 32px;
    }

    .container {
      height: calc(100% - 32px);
      display: flex;
    }
  }

  .tableStyle {
    // height: calc(100vh - 350px);
    width: 100%;
    height: 50%;
    overflow: hidden;
  }
}

.el-tab-pane {
  height: 100% !important;
}

.datePickerWidth {
  width: 150px;
}

.monthForm {
  margin-left: 20px;
}

.btns {
  margin-left: 20px;
}

// /deep/ .el-table--scrollable-x .el-table__body-wrapper {
//   overflow: auto !important;
// }
</style>
